import React, {Component} from "react"
import PropTypes from "prop-types"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Tabs from "@irati/ui/src/Tabs"
import authentication from "@irati/auth"
import {Card} from "@irati/ui/src/Layout"
import {Body} from "@irati/ui/src/Typography"
import mainTheme from "@irati/ui/src/global/theme"
import history from "@irati/utils/history"
import adminTracking, {ViewType, Product} from "@irati-tracking/admin/admin"

import Polls from "../../../components/Reporting/Celebrations/Polls"
import TopCelebrated from "../../../components/Reporting/Celebrations/TopCelebrated"
import RewardTransactions from "../../../components/Reporting/RewardTransactions"
import ValuesAndCelebrations from "../../../components/Reporting/Celebrations/ValuesAndCelebrations"

enum REPORTING_TABS {
  PEOPLE = "celebratedPeople",
  TEAMS = "celebratedTeams",
  VALUES_AND_CELEBRATIONS = "valuesAndCelebrations",
  POLLS = "celebratedPolls",
  REWARD_TRANSACTIONS = "rewardTransactions"
}

interface Props extends InjectIntl {}

interface State {
  activeKey?: string
}
class Celebrations extends Component<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    activeKey: window.location.pathname.split("celebrations/")?.[1]
  }

  componentDidMount = () => {
    this.onTabLoad("celebratedPeople")
  }

  onTabLoad = (tab: string) => {
    switch (tab) {
      case "celebratedPeople":
        return adminTracking.reporting({
          source: "Navigation",
          type: "celebration_people",
          viewType: ViewType.default,
          product: Product.recognitionReceived
        })
      case "celebratedTeams":
        return adminTracking.reporting({
          source: "Navigation",
          type: "celebration_teams",
          viewType: ViewType.default,
          product: Product.recognitionReceived
        })
      case "rewardTransactions":
        return adminTracking.reporting({
          source: "Navigation",
          type: "celebration_rewardTransactions",
          viewType: ViewType.default
        })
      default:
        return null
    }
  }

  getTabs = () => {
    const {formatMessage} = this.props
    return [
      {
        title: formatMessage({id: "admin.reporting.celebrations.people.title"}),
        key: REPORTING_TABS.PEOPLE,
        component: <TopCelebrated />
      },
      {
        title: formatMessage({id: "admin.reporting.celebrations.teams.title"}),
        key: REPORTING_TABS.TEAMS,
        component: <TopCelebrated isTeams />
      },
      {
        title: formatMessage({id: "admin.reporting.celebrations.values.title"}),
        key: REPORTING_TABS.VALUES_AND_CELEBRATIONS,
        component: <ValuesAndCelebrations />
      },
      {
        title: formatMessage({id: "admin.reporting.celebrations.polls.title"}),
        key: REPORTING_TABS.POLLS,
        component: <Polls />
      },
      {
        title: formatMessage({id: "admin.reporting.transactions.title"}),
        key: REPORTING_TABS.REWARD_TRANSACTIONS,
        component: <RewardTransactions isTeams />
      }
    ]
  }

  render() {
    const {activeKey} = this.state

    return authentication.apps("recognition") ? (
      <Tabs
        id="adminSection_reportingTab"
        addMarginTop
        mountOnEnter
        unmountOnExit
        activeKey={activeKey}
        onSelect={(tab) => {
          this.onTabLoad(tab)
          history.push(`/analytics/celebrations/${tab}`, this.context)
          this.setState({activeKey: tab})
        }}
        tabs={this.getTabs()}
      />
    ) : (
      <>
        <Card marginBottom={4} bgColor={mainTheme.colors.greys.lightest}>
          <Body>
            <FormattedMessage id="admin.reporting.turnOnCelebration" />
          </Body>
        </Card>
        <RewardTransactions isTeams />
      </>
    )
  }
}

export default injectIntl(Celebrations)
